/* ============
 * All Business Days
 * ============
 *
 * All cities from a country.
 */

import Vue from 'vue';
import store from '../../store';
import packagingMaterialTransformer from '../../transformers/packagingMaterial';

const success = ({ data }, resolve) => {
  const packagingMaterials = packagingMaterialTransformer.fetchCollection(data.data);

  store.dispatch('fetchPackagingMaterials', packagingMaterials);
  resolve();
};

const failed = () => {
};

// Display cities related to a country.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('packaging_materials')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/packagingMaterial/all.js